<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="12"
                lg="12"
                md="12"
                sm="12">
                <h3>HR Documents</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <hr />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <label>User</label>
                <v-combobox
                    v-model="userSelected"
                    :items="listUsers"
                    item-text="name"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="getRegisters"
                ></v-combobox>
            </v-col>
        </v-row>
        
        <v-tabs
            v-model="tab"
            fixed-tabs
        >
            <v-tab key="1">
                Documents
            </v-tab>
            <v-tab key="2">
                Vacations / PTO
            </v-tab>
            <v-tab key="3">
                PPE Request
            </v-tab>
            <v-tab key="4">
                Vehicle Repair Request
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            
            <!-- DOCUMENTS -->
            <v-tab-item key="1">
                <br />
                
                <v-row>
                    <v-col
                        cols="12"
                        lg="12"
                        md="12"
                        sm="12"
                    >
                        <v-expansion-panels
                            popout
                            multiple
                        >
                            <v-expansion-panel
                                style="margin-bottom: 10px;"
                            >
                                <v-expansion-panel-header>
                                    <v-col
                                        cols="10"
                                        lg="10"
                                        md="10"
                                        sm="10"
                                    >
                                        <label style="font-size: 20px !important; color: black;">Employee Benefits</label>
                                    </v-col>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    
                                    <v-card-text>

                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.EMPLOYEE_BENEFITS_BOOKLET.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(1, TYPE_DOCUMENT.EMPLOYEE_BENEFITS_BOOKLET);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(1, TYPE_DOCUMENT.EMPLOYEE_BENEFITS_BOOKLET);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>
                                        </v-card>                                        
                                    </v-card-text>

                                    
                                    <v-card-text>

                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    Status change requests
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.STATUS_CHANGE_REQUESTS)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(1, TYPE_DOCUMENT.STATUS_CHANGE_REQUESTS);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(1, TYPE_DOCUMENT.STATUS_CHANGE_REQUESTS);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>
                                            <v-card-text style="margin-top: 20px;">
                                                <v-row>
                                                    <v-col
                                                        cols="12"
                                                        lg="12"
                                                        md="12"
                                                        sm="12"
                                                    >
                                                        <span>Upload the document signed</span>
                                                        
                                                        <v-tooltip top>
                                                            <template v-slot:activator="{ on }">
                                                                <v-btn
                                                                    style="width: 100% !important; margin-top: 2rem; margin-left: 0px !important;"
                                                                    class="mx-2"
                                                                    v-on="on"
                                                                >
                                                                    <v-icon left>mdi-file-upload-outline</v-icon>
                                                                    Upload Signed Document
                                                                </v-btn>
                                                            </template>
                                                            <span>Upload Signed Document</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-row>
                                                
                                            </v-card-text>

                                        </v-card>
                                        
                                    </v-card-text>

                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel
                                style="margin-bottom: 10px;"
                            >
                                <v-expansion-panel-header>
                                    <v-col
                                        cols="10"
                                        lg="10"
                                        md="10"
                                        sm="10"
                                    >
                                        <label style="font-size: 20px !important; color: black;">New Employee</label>
                                    </v-col>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    
                                    <!-- Authorization for Background Checks -->
                                    <v-card-text>

                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.AUTHORIZATION_FOR_BACKGROUND_CHECKS.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.AUTHORIZATION_FOR_BACKGROUND_CHECKS)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.AUTHORIZATION_FOR_BACKGROUND_CHECKS);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.AUTHORIZATION_FOR_BACKGROUND_CHECKS);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>
                                    
                                    <!-- Confidentiality and Non-Competition Agreement -->
                                    <v-card-text>
                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.CONFIDENTIALITY_NON_COMPETITION_AGREEMENT.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.CONFIDENTIALITY_NON_COMPETITION_AGREEMENT)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.CONFIDENTIALITY_NON_COMPETITION_AGREEMENT);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.CONFIDENTIALITY_NON_COMPETITION_AGREEMENT);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>
                                    
                                    <!-- Direct Deposit Authorization Agreement -->
                                    <v-card-text>
                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.DIRECT_DEPOSIT_AUTHORIZATION_AGREEMENT.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.DIRECT_DEPOSIT_AUTHORIZATION_AGREEMENT)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.DIRECT_DEPOSIT_AUTHORIZATION_AGREEMENT);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.DIRECT_DEPOSIT_AUTHORIZATION_AGREEMENT);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>
                                    
                                    <!-- Drug Free Workplace Policy -->
                                    <v-card-text>
                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.DRUG_FREE_WORKPLACE_POLICY.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.DRUG_FREE_WORKPLACE_POLICY)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.DRUG_FREE_WORKPLACE_POLICY);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.DRUG_FREE_WORKPLACE_POLICY);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>
                                    
                                    <!-- EEO Self Identification Form -->
                                    <v-card-text>
                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.EEO_SELF_IDENTIFICATION_FORM.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.EEO_SELF_IDENTIFICATION_FORM)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.EEO_SELF_IDENTIFICATION_FORM);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.EEO_SELF_IDENTIFICATION_FORM);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>
                                    
                                    <!-- Employee Information -->
                                    <v-card-text>
                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.EMPLOYEE_INFORMATION.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.EMPLOYEE_INFORMATION)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.EMPLOYEE_INFORMATION);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.EMPLOYEE_INFORMATION);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>
                                    
                                    <!-- I9 Paper Version -->
                                    <v-card-text>
                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.I9_PAPER_VERSION.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.I9_PAPER_VERSION)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.I9_PAPER_VERSION);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.I9_PAPER_VERSION);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>
                                    
                                    <!-- Information Brochure for Injured Workers -->
                                    <v-card-text>
                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.INFORMATION_BROCHURE_FOR_INJURED_WORKERS.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.INFORMATION_BROCHURE_FOR_INJURED_WORKERS)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.INFORMATION_BROCHURE_FOR_INJURED_WORKERS);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.INFORMATION_BROCHURE_FOR_INJURED_WORKERS);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>
                                    
                                    <!-- Introductory Period Acknowledgement -->
                                    <v-card-text>
                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.INTRODUCTORY_PERIOD_ACKNOWLEDGEMENT.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.INTRODUCTORY_PERIOD_ACKNOWLEDGEMENT)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.INTRODUCTORY_PERIOD_ACKNOWLEDGEMENT);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.INTRODUCTORY_PERIOD_ACKNOWLEDGEMENT);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>
                                    
                                    <!-- Non Solicitation -->
                                    <v-card-text>
                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.NON_SOLICITATION.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.NON_SOLICITATION)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.NON_SOLICITATION);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.NON_SOLICITATION);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>
                                    
                                    <!-- Receipt of Handbook Acknowledgement -->
                                    <v-card-text>
                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.RECEIPT_HANDBOOK_ACKNOWLEDGEMENT.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.RECEIPT_HANDBOOK_ACKNOWLEDGEMENT)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.RECEIPT_HANDBOOK_ACKNOWLEDGEMENT);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.RECEIPT_HANDBOOK_ACKNOWLEDGEMENT);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>
                                    
                                    <!-- Terms of Employment -->
                                    <v-card-text>
                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.TERMS_EMPLOYMENT.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.TERMS_EMPLOYMENT)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.TERMS_EMPLOYMENT);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.TERMS_EMPLOYMENT);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>
                                    
                                    <!-- Van Kirk & Sons - Handbok -->
                                    <v-card-text>
                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.VANKIRKSONS_HANDBOK.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.VANKIRKSONS_HANDBOK)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.VANKIRKSONS_HANDBOK);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.VANKIRKSONS_HANDBOK);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>
                                    
                                    <!-- Worker Compensation Employee Acknowledgement -->
                                    <v-card-text>
                                        <v-card
                                            class="mx-auto"
                                        >
                                            <v-card-title class="text-h5 lighten-2" style="border-bottom: solid 1px var(--color__cinza)">
                                                <v-col cols="4">
                                                    {{ TYPE_DOCUMENT.WORKER_COMPENSATION_EMPLOYEE_ACKNOWLEDGEMENT.description }}
                                                </v-col>
                                                <v-col cols="8" style="text-align: right;">
                                                    <v-chip
                                                        v-if="userIsSelected"
                                                        style="font-size: 12px !important;"
                                                        :color="statusColorEmployeeBenefitsBooklet"
                                                        outlined
                                                        dark
                                                    >
                                                        {{ statusDescriptionEmployeeBenefitsBooklet }}
                                                    </v-chip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="primary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="showDialogDocusign(TYPE_DOCUMENT.WORKER_COMPENSATION_EMPLOYEE_ACKNOWLEDGEMENT)"
                                                            >
                                                                Docusign
                                                            </v-chip>
                                                        </template>
                                                        <span>Click to view docusign options</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="uploadFile(0, TYPE_DOCUMENT.WORKER_COMPENSATION_EMPLOYEE_ACKNOWLEDGEMENT);"
                                                            >
                                                                Update
                                                            </v-chip>
                                                        </template>
                                                        <span>Update Document</span>
                                                    </v-tooltip>

                                                    <v-tooltip 
                                                        v-if="userIsSelected"
                                                        top
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-chip
                                                                v-if="userIsSelected"
                                                                style="font-size: 12px !important; margin-left: 10px;"
                                                                v-on="on"
                                                                color="secondary"
                                                                outlined
                                                                dark
                                                                link
                                                                @click="openFiles(0, TYPE_DOCUMENT.WORKER_COMPENSATION_EMPLOYEE_ACKNOWLEDGEMENT);"
                                                            >
                                                                History
                                                            </v-chip>
                                                        </template>
                                                        <span>History of all documents</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-card-title>

                                        </v-card>
                                        
                                    </v-card-text>

                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            
                        </v-expansion-panels>
                    </v-col>
                </v-row>                
                    
            </v-tab-item>

            <!-- VACATIONS / PERSONAL LEAVE REQUEST -->
            <v-tab-item key="2">
                <br />
                
                <v-row>
                    <v-col 
                        cols="12"
                        lg="12"
                        md="12"
                        sm="12"
                    >
                        <v-data-table
                            :headers="headersVacation"
                            :items="listVacation"
                            :options.sync="options"
                            :loading="loading"
                            :items-per-page="10"
                            no-data-text="No Record Found"
                        >
                            <template v-slot:item.statusDescription="{ item }">
                                <v-chip
                                    :color="getStatusColor(item.status)"
                                    outlined
                                    dark
                                >
                                    {{ item.statusDescription }}
                                </v-chip>
                            </template>
                            
                            <template v-slot:item.action="{item}">
                                <ActionList 
                                    :id="item.id" 
                                    :showButtons="{
                                        check: item.status == 1,
                                        download: true
                                    }"
                                    @confirmCheck="confirmCheck"
                                    @confirmDownload="confirmDownload"
                                />
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-tab-item>

            <!-- PPE REQUEST -->
            <v-tab-item key="3">
                <br />
                
                <v-row>
                    <v-col 
                        cols="12"
                        lg="12"
                        md="12"
                        sm="12"
                    >
                        <v-data-table
                            :headers="headersPpe"
                            :items="listPpe"
                            :options.sync="options"
                            :loading="loading"
                            :items-per-page="10"
                            no-data-text="No Record Found"
                        >
                            <template v-slot:item.statusDescription="{ item }">
                                <v-chip
                                    :color="getStatusColor(item.status)"
                                    outlined
                                    dark
                                >
                                    {{ item.statusDescription }}
                                </v-chip>
                            </template>
                            
                            <template v-slot:item.action="{item}">
                                <ActionList 
                                    :id="item.id" 
                                    :showButtons="{
                                        check: item.status == 1,
                                        download: true
                                    }"
                                    @confirmCheck="confirmCheckPpe"
                                    @confirmDownload="confirmDownloadPpe"
                                />
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-tab-item>

            <!-- VEHICLE REPAIR REQUEST -->
            <v-tab-item key="4">
                <br />
                
                <v-row>
                    <v-col 
                        cols="12"
                        lg="12"
                        md="12"
                        sm="12"
                    >
                        <v-data-table
                            :headers="headersVehicle"
                            :items="listVehicle"
                            :options.sync="options"
                            :loading="loading"
                            :items-per-page="10"
                            no-data-text="No Record Found"
                        >
                            <template v-slot:item.statusDescription="{ item }">
                                <v-chip
                                    :color="getStatusColor(item.status)"
                                    outlined
                                    dark
                                >
                                    {{ item.statusDescription }}
                                </v-chip>
                            </template>
                            
                            <template v-slot:item.action="{item}">
                                <ActionList 
                                    :id="item.id" 
                                    :showButtons="{
                                        check: item.status == 1,
                                        download: true
                                    }"
                                    @confirmCheck="confirmCheckVehicle"
                                    @confirmDownload="confirmDownloadVehicle"
                                />
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-tab-item>

        </v-tabs-items>

        <!-- VACATION -->
        <v-dialog
            v-model="showVacationDetails"
            transition="dialog-top-transition"
            width="1200"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
                <v-card>
                    <v-card-title class="lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza); font-size: 17px;">
                        Form Request
                    </v-card-title>

                    <v-card-text style="margin-top: 20px;">
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Employee Name </label>
                                <v-text-field
                                    v-model="vacationRequest.userName" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="2"
                                md="2"
                                sm="12"
                            >
                                <label>Type</label>
                                <v-text-field
                                    v-model="vacationRequest.typeTimeDescription" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>
                            
                            <v-col 
                                cols="12"
                                lg="3"
                                md="3"
                                sm="12"
                            >
                                <label>Leave to Start</label>
                                <v-text-field
                                    v-model="vacationRequest.startDateFormatted" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>
                            
                            <v-col 
                                cols="12"
                                lg="3"
                                md="3"
                                sm="12"
                            >
                                <label>Expect to Return</label>
                                <v-text-field
                                    v-model="vacationRequest.endDateFormatted" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>

                            <v-col 
                                cols="12"
                                lg="4"
                                md="4"
                                sm="12"
                            >
                                <label>Type</label>
                                <v-text-field
                                    v-model="vacationRequest.typeVacationDescription" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col 
                                cols="12"
                                lg="2"
                                md="2"
                                sm="12"
                            >
                                <label>Time off Selection</label>
                                <v-text-field
                                    v-model="vacationRequest.typeLeaveDescription" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>
                            <v-col 
                                cols="12"
                                lg="3"
                                md="3"
                                sm="12"
                            >
                                <label>Days Allocated - Paid Leave</label>
                                <v-text-field
                                    v-model="vacationRequest.daysAllocatedPaid" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>
                            <v-col 
                                cols="12"
                                lg="3"
                                md="3"
                                sm="12"
                            >
                                <label>Days Allocated - Unpaid Leave</label>
                                <v-text-field
                                    v-model="vacationRequest.daysAllocatedUnpaid" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Explanation</label>
								<v-textarea
									v-model="vacationRequest.description"
									single-line
									rows="3"
									row-height="30"
									outlined
                                    readonly
								>
								</v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions style="padding: 15px !important;">
                        <div style="width: 100%; text-align: center;">
                            <v-btn
                                class="mx-2 dialogButtonCancel v-btn-large"
                                outlined
                                @click="showDialogApproveOrDenyConfirmation(3, 'VAC')"
                            >
                                Deny
                            </v-btn>

                            <v-btn
                                class="mx-2 v-btn-large"
                                outlined
                                @click="showDialogApproveOrDenyConfirmation(2, 'VAC')"
                            >
                                Approve
                            </v-btn>
                        </div>
                    </v-card-actions>

                </v-card>
        </v-dialog>

        <!-- PPE -->
        <v-dialog
            v-model="showPpeDetails"
            transition="dialog-top-transition"
            width="1200"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
                <v-card>
                    <v-card-title class="lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza); font-size: 17px;">
                        PPE Form Request
                    </v-card-title>

                    <v-card-text style="margin-top: 20px;">
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Employee Name </label>
                                <v-text-field
                                    v-model="ppeRequest.userName" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>PPE Needed</label>
								<v-textarea
									v-model="ppeRequest.description"
									single-line
									rows="3"
									row-height="30"
									outlined
                                    readonly
								>
								</v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions style="padding: 15px !important;">
                        <div style="width: 100%; text-align: center;">
                            <v-btn
                                class="mx-2 dialogButtonCancel v-btn-large"
                                outlined
                                @click="showDialogApproveOrDenyConfirmation(3, 'PPE')"
                            >
                                Deny
                            </v-btn>

                            <v-btn
                                class="mx-2 v-btn-large"
                                outlined
                                @click="showDialogApproveOrDenyConfirmation(2, 'PPE')"
                            >
                                Approve
                            </v-btn>
                        </div>
                    </v-card-actions>

                </v-card>
        </v-dialog>

        <!-- VEHICLE -->
        <v-dialog
            v-model="showVehicleDetails"
            transition="dialog-top-transition"
            width="1200"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
                <v-card>
                    <v-card-title class="lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza); font-size: 17px;">
                        Vehicle Repair Request
                    </v-card-title>

                    <v-card-text style="margin-top: 20px;">
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Employee Name </label>
                                <v-text-field
                                    v-model="vehicleRequest.userName" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="12"
                                lg="2"
                                md="2"
                                sm="12"
                            >
                                <label>Driver Name</label>
                                <v-text-field
                                    v-model="vehicleRequest.driverName" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>
                            
                            <v-col 
                                cols="12"
                                lg="3"
                                md="3"
                                sm="12"
                            >
                                <label>Vehicle</label>
                                <v-text-field
                                    v-model="vehicleRequest.vehicle" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>
                            
                            <v-col 
                                cols="12"
                                lg="3"
                                md="3"
                                sm="12"
                            >
                                <label>Tag</label>
                                <v-text-field
                                    v-model="vehicleRequest.tag" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>

                            <v-col 
                                cols="12"
                                lg="4"
                                md="4"
                                sm="12"
                            >
                                <label>Cuurent Mileage</label>
                                <v-text-field
                                    v-model="vehicleRequest.currentMileage" 
                                    single-line
                                    outlined
                                    dense
                                    readonly
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col 
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <label>Repair Needed</label>
								<v-textarea
									v-model="vehicleRequest.description"
									single-line
									rows="3"
									row-height="30"
									outlined
                                    readonly
								>
								</v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                v-for="(itemPhoto, index) in vehiclePhotos.filter(pht => pht.deleted == false)"
                                :key="index"
                                cols="12"
                                lg="2"
                                md="4"
                                sm="12"
                            >
                                <v-card max-width="200">
                                    <v-img
                                        :src="itemPhoto.src"
                                        :lazy-src="itemPhoto.src"
                                        aspect-ratio="1"
                                        max-height="200"
                                        max-width="200"
                                        style="cursor: pointer;"
                                        @click="downloadFile(URL_ATTACHMENT, itemPhoto.id, itemPhoto.fileType, itemPhoto.fileNameComplete)"
                                    >
                                        <template v-slot:placeholder>
                                        <v-row
                                            class="fill-height ma-0"
                                            align="center"
                                            justify="center"
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                color="grey lighten-5"
                                            ></v-progress-circular>
                                        </v-row>
                                        </template>
                                    </v-img>
                                    <span class="imageFileName">{{ itemPhoto.fileName }}</span>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions style="padding: 15px !important;">
                        <div style="width: 100%; text-align: center;">
                            <v-btn
                                class="mx-2 dialogButtonCancel v-btn-large"
                                outlined
                                @click="showDialogApproveOrDenyConfirmation(3, 'VEH')"
                            >
                                Deny
                            </v-btn>

                            <v-btn
                                class="mx-2 v-btn-large"
                                outlined
                                @click="showDialogApproveOrDenyConfirmation(2, 'VEH')"
                            >
                                Approve
                            </v-btn>
                        </div>
                    </v-card-actions>

                </v-card>
        </v-dialog>

        <v-dialog
            v-model="showDialogApproveOrDeny"
            transition="dialog-top-transition"
            persistent
            width="900"
            :fullscreen="$vuetify.breakpoint.mobile"
        >
            <v-card>
                <v-card-title class="text-h5 lighten-2 formDialog" style="border-bottom: solid 1px var(--color__cinza)">
                    Confirmation
                </v-card-title>

                <v-card-text style="margin-top: 20px;">
                    <v-row>
                        <v-col 
                            cols="12"
                            lg="12"
                            md="12"
                            sm="12"
                        >
                            <label>Description</label>
                            <v-textarea
                                v-model="description"
                                single-line
                                rows="4"
                                row-height="30"
                                outlined
                            >
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <div style="width: 100%; text-align: center;">
                        <v-btn
                            class="mx-2 dialogButtonDismiss v-btn-large"
                            outlined
                            @click="showDialogApproveOrDeny = false"
                        >
                            Cancel
                        </v-btn>

                        <v-btn
                            class="mx-2 v-btn-large"
                            outlined
                            @click="confirmApproveOrDeny()"
                        >
                            Confirm
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <DialogDocusign 
            v-on:methodConfirmToCall="dialogDocusign.methodConfirm"
            :showDialogDocusign.sync="dialogDocusign.show"
            :idAux="dialogDocusign.idAux"
            :id="dialogDocusign.id"
            :typeDocument="dialogDocusign.typeDocument"
            :customer="dialogDocusign.customer"
        />

        <ActionDialog 
            v-on:methodConfirmToCall="dialog.methodConfirm"
            :showDialog.sync="dialog.show"
            :headerTitle="dialog.headerText"
            :bodyText="dialog.bodyText"
            :params="dialog.params"
        />

        <UploadFile 
            v-on:methodConfirmAfterUpload="dialogUploadFile.methodAfterUpload"
            :showUploadFile.sync="dialogUploadFile.show"
            :idKey="dialogUploadFile.idKey"
            :reload="dialogUploadFile.reload"
            :acceptType="dialogUploadFile.acceptType"
            :typeAttachment="dialogUploadFile.typeAttachment"
            :typeDocument="dialogUploadFile.typeDocument"
            :multipleFiles="dialogUploadFile.multipleFiles"
            :showMsgConfirmation="dialogUploadFile.showMsgConfirmation"
            :msgConfirmation="dialogUploadFile.msgConfirmation"
        />

        <ShowFiles 
            :showFiles.sync="dialogShowFiles.show"
            :title="dialogShowFiles.title"
            :showAsCarrousel.sync="dialogShowFiles.showAsCarrousel"
            :showFilters="dialogShowFiles.showFilters"
            :reload="dialogShowFiles.reload"
            :listParams="dialogShowFiles.listParams"
        />
        
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';    
    import ActionList from "@/components/Layout/ActionList";
    import ActionDialog from "@/components/Layout/ActionDialog";
    import DialogDocusign from "@/components/Services/DialogDocusign";
    import UploadFile from "@/components/File/UploadFile";
    import ShowFiles from "@/components/File/ShowFiles";
    import {
        URL_ATTACHMENT,
        TYPE_ATTACHMENT,
        TYPE_DOCUMENT, 
        URL_VACATION_REQUEST_PDF,
        URL_PPE_REQUEST_PDF,
        URL_VEHICLE_REQUEST_PDF
    } from "@/utilities/Enums";

    export default ({

        components: {
            ActionList,
            ActionDialog,
            DialogDocusign,
            UploadFile,
            ShowFiles
        },

        mixins: [Helpers],

        data: () => ({

            tab: null,

            listTutorial: [],
            listUsers: [],

            userSelected: null,
            
            statusColorEmployeeBenefitsBooklet: "var(--color__alert)",
            statusDescriptionEmployeeBenefitsBooklet: "Pending",
            
            dialogDocusign: {
                show: false,
                idAux: 0,
                id: 0,
                typeDocument: null,
                customer: null,
                methodConfirm: ( () => {} )
            },

            showDialogApproveOrDeny: false,
            description: '',
            statusId: 0, 
            typeRequest: '',

            //VACATION
            showVacationDetails: false,     
            listVacation: [],
            vacationRequest: {
                userName: "",
                timeTypeDescription: "",
                startDateFormatted: null,
                endDateFormatted: null,
                typeVacationDescription: "",
                typeLeaveDescription: "",
                daysAllocatedPaid: null,
                daysAllocatedUnpaid: null,
                description: ""
            },

            headersVacation: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Leave To Start", value: "startDateFormatted", sortable: true },
                { text: "Expect to Return", value: "endDateFormatted", sortable: true },
                { text: "Type", value: "typeVacationDescription", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            //PPE            
            showPpeDetails: false,     
            listPpe: [],
            ppeRequest: {
                userName: "",
                description: ""
            },

            headersPpe: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "PPE Needed", value: "description", sortable: true },
                { text: "Approved On", value: "dateApproveOrDenyFormatted", sortable: true },
                { text: "Approved By", value: "userNameApproveOrDeny", sortable: true },
                { text: "Reason", value: "reason", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],

            //VEHICLE            
            showVehicleDetails: false,     
            listVehicle: [],
            vehicleRequest: {
                userName: "",
                driverName: "",
                vehicle: "",
                tag: "",
                currentMileage: "",
                description: ""
            },

            headersVehicle: [
                { text: "ID", value: "id", sortable: true, size: "5%" },
                { text: "Created On", value: "dateRegisterFormatted", sortable: true },
                { text: "Driver Name", value: "driverName", sortable: true },
                { text: "Vehicle", value: "vehicle", sortable: true },
                { text: "Approved On", value: "dateApproveOrDenyFormatted", sortable: true },
                { text: "Approved By", value: "userNameApproveOrDeny", sortable: true },
                { text: "Reason", value: "reason", sortable: true },
                { text: "Status", value: "statusDescription", sortable: true },
                { text: "Actions", value: "action", sortable: false, align: "center" }
            ],
            vehiclePhotos: [],
            
            loading: false,      

            options: { rowsPerPage: 10, page: 1 },

            dialog: {
                show: false,
                headerText: "",
                bodyText: "",
                methodConfirm: ( () => {} ),
                params: null
            },

            dialogUploadFile: {
                show: false,
                idKey: 0,
                reload: 0,
                acceptType: ".pdf",
                typeAttachment: 0,
                typeDocument: 0,
                multipleFiles: false,
                showMsgConfirmation: true,
                msgConfirmation: "",
                methodAfterUpload: ( () => {} ),
            },
            
            dialogShowFiles: {
                show: false,
                title: '',
                showAsCarrousel: true,
                showFilters: false,
                reload: 0,
                listParams: []
            },

            URL_ATTACHMENT,
            TYPE_DOCUMENT,
            URL_VACATION_REQUEST_PDF,
            URL_PPE_REQUEST_PDF,
            URL_VEHICLE_REQUEST_PDF
        }),

        props: {
            id: {
                default: 0
            },

            params: {
                default: ""
            }
        },

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            userIsSelected() {
                return this.userSelected != null && this.userSelected != undefined;
            }
        },

        methods: {

            getStatusColor (status) {

                let color = "";

                switch (status) {

                    //DRAFT
                    case 0:
                        color = 'var(--color__silver)';
                        break;

                    //PENDING
                    case 1:
                        color = 'var(--color__status_pending)';
                        break;

                    //APPROVED
                    case 2:
                        color = 'var(--color__main)';
                        break;

                    //DENIED or CANCELLED
                    case 3:
                    case 99:
                        color = 'var(--color__red)';
                        break;
                
                    default:
                        break;
                }

                return color
            },

            async getLists() {
                this.listUsers = await this.$store.dispatch("userModule/List");
            },

            async getRegisters() {
                this.showLoading();

                let idUser = 0;

                if (this.userSelected != null && this.userSelected != undefined) {
                    idUser = this.userSelected.id;
                }

                this.listVacation = await this.$store.dispatch("vacationModule/ListByUser", idUser);
                this.listPpe = await this.$store.dispatch("ppeModule/ListByUser", idUser);
                this.listVehicle = await this.$store.dispatch("vehicleModule/ListByUser", idUser);

                this.hideLoading();
            },

            async showDialogApproveOrDenyConfirmation(statusId, typeRequest) {
                this.statusId = statusId;
                this.typeRequest = typeRequest;
                this.showDialogApproveOrDeny = true;
            },

            confirmApproveOrDeny() {

                this.dialog = {
                    show: true,
                    headerText: 'Confirmation',
                    bodyText: `You will ${this.statusId == 2 ? 'APPROVE' : 'DENY'} this request, confirm your decision?`,
                    methodConfirm: this.typeRequest == 'VAC' ? this.updateVacationStatus : this.typeRequest == 'PPE' ? this.updatePpeStatus : this.updateVehicleStatus,
                    params: 0
                };

            },

            //VACATION
            async confirmCheck(id) {

                this.showLoading();

                const vacationResult = await this.$store.dispatch("vacationModule/GetById", id);

                if (vacationResult.success) {
                    this.vacationRequest = vacationResult.result;

                    this.showVacationDetails = true;
                }

                this.hideLoading();
            },

            async updateVacationStatus() {

                this.showLoading();
                const vacationStatusRequest = {
                    id: this.vacationRequest.id,
                    status: this.statusId,
                    reason: this.description
                };

                const result = await this.$store.dispatch("vacationModule/UpdateStatus", vacationStatusRequest);

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                    this.showDialogApproveOrDeny = false;
                    this.showVacationDetails = false;
                    this.getRegisters();
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getLists();

                this.hideLoading();
            },

            async confirmDownload(id) {
                this.downloadFile(URL_VACATION_REQUEST_PDF, id, 'application/pdf', 'Vacation-Personal Leave Request Form.pdf')
            },

            //PPE
            async confirmCheckPpe(id) {

                this.showLoading();

                const ppeResult = await this.$store.dispatch("ppeModule/GetById", id);

                if (ppeResult.success) {
                    this.ppeRequest = ppeResult.result;

                    this.showPpeDetails = true;
                }

                this.hideLoading();
            },

            async updatePpeStatus() {

                this.showLoading();
                const ppeStatusRequest = {
                    id: this.ppeRequest.id,
                    status: this.statusId,
                    reason: this.description
                };

                const result = await this.$store.dispatch("ppeModule/UpdateStatus", ppeStatusRequest);

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                    this.showDialogApproveOrDeny = false;
                    this.showPpeDetails = false;
                    this.getRegisters();
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getLists();

                this.hideLoading();
            },

            async confirmDownloadPpe(id) {
                this.downloadFile(URL_PPE_REQUEST_PDF, id, 'application/pdf', 'PPE Request Form.pdf')
            },

            //VEHICLE
            async confirmCheckVehicle(id) {

                this.showLoading();

                const vehicleResult = await this.$store.dispatch("vehicleModule/GetById", id);

                if (vehicleResult.success) {
                    this.vehicleRequest = vehicleResult.result;

                    this.vehiclePhotos = [];

                    const listAttachments = await this.$store.dispatch("attachmentModule/GetAll", { typeAttachment: TYPE_ATTACHMENT.HR.value, idKey: this.vehicleRequest.id });
                    const listPhotos = listAttachments.filter(atc => atc.typeDocument == TYPE_DOCUMENT.VEHICLE_PHOTOS.value);  
                    listPhotos.forEach(itemPhoto => {

                        this.vehiclePhotos.push({
                            id: itemPhoto.id,
                            file: new File([], itemPhoto.fileName),
                            type: itemPhoto.fileType,
                            fileName: itemPhoto.fileNameShort,
                            fileNameComplete: itemPhoto.fileName,
                            deleted: false,
                            src: `data:image/jpg;base64,${itemPhoto.file}`
                        })
                    })

                    this.showVehicleDetails = true;
                }

                this.hideLoading();
            },

            async updateVehicleStatus() {

                this.showLoading();
                const vehicleStatusRequest = {
                    id: this.vehicleRequest.id,
                    status: this.statusId,
                    reason: this.description
                };

                const result = await this.$store.dispatch("vehicleModule/UpdateStatus", vehicleStatusRequest);

                if (result.success) {
                    this.showToast("success", "Success!", result.message);
                    this.showDialogApproveOrDeny = false;
                    this.showVehicleDetails = false;
                    this.getRegisters();
                }
                else {
                    this.showToast("error", "Error!", result.message);
                }

                this.getLists();

                this.hideLoading();
            },

            async confirmDownloadVehicle(id) {
                this.downloadFile(URL_VEHICLE_REQUEST_PDF, id, 'application/pdf', 'Vehicle Repair Request Form.pdf')
            },

            async showDialogDocusign(typeDocument) {

                if (this.userSelected == null || this.userSelected == undefined) {
                    this.showToast("warning", "Warning!", "Please select a user to proceed with the docusign process.");
                    return;
                }
                else {
                    const user = {
                        name: this.userSelected.name,
                        email: this.userSelected.email,
                    }

                    this.dialogDocusign = {
                        show: true,
                        idAux: Math.random(),
                        id: this.id,
                        typeDocument,
                        customer: user,
                        methodConfirm: () => {
                            this.getRegister();
                        }
                    }
                }
            },

            async checkParams() {

                if (this.params != null && this.params != undefined && this.params != "" ) {
                    const jsonParams = JSON.parse(this.params);

                    if (jsonParams != null && jsonParams != undefined) {

                        if (jsonParams.vacation) {
                            this.tab = jsonParams.vacation.tab;
                            const userSelected = this.listUsers.find(user => user.id === jsonParams.vacation.idUser);
                            this.userSelected = userSelected || null;
                            await this.getRegisters();
                            await this.confirmCheck(jsonParams.vacation.idVacation);
                        }

                        else if (jsonParams.ppe) {
                            this.tab = jsonParams.ppe.tab;
                            const userSelected = this.listUsers.find(user => user.id === jsonParams.ppe.idUser);
                            this.userSelected = userSelected || null;
                            await this.getRegisters();
                            await this.confirmCheckPpe(jsonParams.ppe.idPpe);
                        }

                        else if (jsonParams.vehicle) {
                            this.tab = jsonParams.vehicle.tab;
                            const userSelected = this.listUsers.find(user => user.id === jsonParams.vehicle.idUser);
                            this.userSelected = userSelected || null;
                            await this.getRegisters();
                            await this.confirmCheckVehicle(jsonParams.vehicle.idVehicle);
                        }
                    }
                }
            },

            async getUserIDSelected() {
                if (this.userIsSelected == true) {
                    return this.userSelected.id;
                } else {
                    return null;
                }
            },

            async uploadFile(id, typeDocument) {
                if (id == 0) {
                    id = await this.getUserIDSelected();
                }

                if (id != null && id != undefined && id != 0) {
                    this.dialogUploadFile = {
                        show: true,
                        idKey: id,
                        reload: Math.random(),
                        acceptType: ".pdf",
                        typeAttachment: TYPE_ATTACHMENT.HR.value,
                        typeDocument: typeDocument.value,
                        multipleFiles: false,
                        showMsgConfirmation: true,
                        msgConfirmation: `You are about to upload <strong>${typeDocument.description}</strong> document to the system, confirm this decision?`,
                        methodAfterUpload: this.getRegisters,
                    };
                }
            },
            
            async openFiles(id, typeDocument) {

                if (id == 0) {
                    id = await this.getUserIDSelected();
                }

                if (id != 0) {
                    const listParams = [{
                        stageDescription: '',
                        typeAttachment: TYPE_ATTACHMENT.HR.value,
                        typeDocument: typeDocument.value,
                        idKey: id,
                        isImage: false
                    }];

                    this.dialogShowFiles = {
                        show: true,
                        idServiceProject: 0,
                        title: typeDocument.description,
                        showAsCarrousel: false,
                        showFilters: false,
                        reload: Math.random(),
                        listParams
                    };
                }
            },
        },

        async created() {
            this.showLoading();

            await this.getLists();
            await this.checkParams();

            this.hideLoading();
        }
    })
</script>
